import { render, staticRenderFns } from "./GestionUsuarios.vue?vue&type=template&id=bf2d21ea&scoped=true"
import script from "./GestionUsuarios.vue?vue&type=script&lang=js"
export * from "./GestionUsuarios.vue?vue&type=script&lang=js"
import style0 from "./GestionUsuarios.vue?vue&type=style&index=0&id=bf2d21ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2d21ea",
  null
  
)

export default component.exports